export default __webpack_public_path__ + "static/media/song4.9477260d.mp3";